import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { NpsService } from '@api/nps/nps.service';
import { isNil } from 'lodash';
import { NetPromoterScoreModalComponent } from './net-promoter-score-modal.component';

@Injectable({
  providedIn: 'root'
})
export class NetPromoterScoreModalService {

  constructor(
    private matDialog: MatDialog,
    private npsService: NpsService
  ) {}

  public async open(): Promise<void> {
    const nps = await this.npsService.getNps();

    if (!isNil(nps)) { return; }

    return this.matDialog.open(NetPromoterScoreModalComponent, { panelClass: 'nps-dialog' })
      .afterClosed()
      .toPromise();
  }

  public close(): void {
    this.matDialog.closeAll();
  }

  public async saveNPS(score: number, comment: string): Promise<void> {
    await this.npsService.postNps(score, comment);
  }
}
